import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {EmailRegexValidatorDirective} from "./email-regex-validator.directive";



@NgModule({
  declarations: [EmailRegexValidatorDirective],
  imports: [
    CommonModule
  ],
  exports: [EmailRegexValidatorDirective]
})
export class EmailRegexValidatorModule { }
